'use client';

import { Dispatch, SetStateAction, useEffect, useState } from 'react';

import breakpoints from '@/lib/breakpoints';
import { mediaURL } from '@/lib/sslByDomain';
import { useMediaQuery } from '@/hooks/useMediaQuery';

import { Poster, VideoJsSection, VideoJSSources } from '@/models/Videojs';

import VideoPlayer from './VideoPlayer';
import VideoPoster from './VideoPoster';

export default function VideoJS(props: VideoJSSources & VideoJsSection) {
  const isDesktop = useMediaQuery(`(min-width: ${breakpoints.md})`);
  const { src, sectionTitle, sectionDescription, poster, videoposter } = props;
  const [desktop, setDesktop]: [
    boolean | undefined,
    Dispatch<SetStateAction<boolean | undefined>>,
  ] = useState();
  const [posterSSL, setPosterSSL] = useState<Poster | undefined>();

  useEffect(() => {
    if (poster)
      setPosterSSL({
        id: poster.id,
        mediaItemUrl: poster.mediaItemUrl,
        altText: poster.altText,
      });
  }, [poster]);

  useEffect(() => {
    setDesktop(isDesktop);
  }, [isDesktop]);

  return (
    <>
      {!desktop && sectionTitle && (
        <div className='flex flex-col items-center gap-5 pb-12 text-center md:pb-0'>
          <VideoPoster
            sectionTitle={sectionTitle}
            sectionDescription={sectionDescription}
            videoposter={videoposter}
          />
        </div>
      )}
      {src && (
        <div className='section-highlights__container relative mx-auto aspect-video overflow-hidden rounded-2xl md:rounded-[2rem]'>
          <VideoPlayer
            src={mediaURL(src)}
            sectionTitle={sectionTitle}
            sectionDescription={sectionDescription}
            poster={posterSSL}
            videoposter={videoposter}
            desktop={desktop}
          />
        </div>
      )}
    </>
  );
}
